import { render, staticRenderFns } from "./VenueHeader.vue?vue&type=template&id=7aa9b255&scoped=true"
import script from "./VenueHeader.vue?vue&type=script&lang=ts"
export * from "./VenueHeader.vue?vue&type=script&lang=ts"
import style0 from "./VenueHeader.vue?vue&type=style&index=0&id=7aa9b255&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa9b255",
  null
  
)

export default component.exports